import React, { useState } from 'react';
import Review from '../components/review';
import '../css/Home.css';
import '../css/Service.css';

const Manufacturing = () => {
  const [previewSrc, setPreviewSrc] = useState(null);

  const showPreview = (src) => setPreviewSrc(src);
  const hidePreview = () => setPreviewSrc(null);

  return (
    <div className="service-page">
      {previewSrc && (
        <div
          onClick={hidePreview}
          onMouseLeave={hidePreview}
          role="button"
          tabIndex={0}
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 2000,
            cursor: 'zoom-out'
          }}
        >
          <img src={previewSrc} alt="Preview" style={{ maxWidth: '92%', maxHeight: '92%', boxShadow: '0 6px 30px rgba(0,0,0,0.6)' }} />
        </div>
      )}

      <div className="service-banner">
        <img src="/manufacture_01.jpeg" alt="Manufacturing Banner" className="service-banner-img" onMouseEnter={() => showPreview('/manufacture_01.jpeg')} onClick={() => showPreview('/manufacture_01.jpeg')} />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Custom Manufacturing for Healthcare & Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>Engineering Excellence: Custom Manufacturing</h1>
        <p>Design and manufacture of medical-grade equipment and thermal processing units.</p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Advanced Thermal Solutions</h2>
          <p style={{ textAlign: 'justify' }}>
            We design and manufacture high-performance systems for total waste destruction and sterilization, including custom-built incinerators and industrial autoclaves.
          </p>

          <h3>Custom-Built Incinerators</h3>
          <ul>
            <li>Multiple capacities (50kg/hr to 1,000kg/hr+).</li>
            <li>Primary and secondary combustion chambers for complete smokeless burn.</li>
            <li>Designed for medical, industrial, and hazardous waste compliance.</li>
          </ul>

          <h3>Industrial Autoclaves</h3>
          <ul>
            <li>Heavy-duty pressure vessels for high-volume sterilization.</li>
            <li>Automated control systems for temperature and pressure monitoring.</li>
            <li>Corrosion-resistant stainless steel construction for long service life.</li>
          </ul>

          <h3>Hospital Furniture & Patient Care Equipment</h3>
          <p style={{ textAlign: 'justify' }}>
            We manufacture hospital furniture finished with anti-microbial powder coating and high-grade welding for continuous clinical use.
          </p>
          <ul>
            <li>Mobility Solutions: wheelchairs, patient stretchers.</li>
            <li>Ward Essentials: IV stands, bedside lockers, over-bed tables.</li>
            <li>Surgical Equipment: instrument trolleys, OT trays.</li>
            <li>Specialised Trollies: laundry, medicine, and leak-proof waste collection trollies.</li>
          </ul>

          <h3>Industrial Iron & Steel Fabrication</h3>
          <p style={{ textAlign: 'justify' }}>
            Stainless steel sinks, scrub stations, storage racking, and mortuary equipment built to specification.
          </p>

          <h3>Why Choose Clean World Manufacturing?</h3>
          <p style={{ textAlign: 'justify' }}>
            We provide installation, staff training, and long-term maintenance—delivering turnkey solutions for facilities of any size.
          </p>

          <div className="service-cta mt-3">
            <a href="/contact" className="btn btn-primary">Get a Quote</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="image-pair" style={{ marginBottom: '1rem' }}>
            <img src="/manufacture_01.jpeg" alt="Manufacture" style={{ width: '100%', height: '300px', objectFit: 'cover', marginBottom: '0.5rem', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/manufacture_01.jpeg')} onClick={() => showPreview('/manufacture_01.jpeg')} />
            <img src="/manufacture_02.jpeg" alt="Manufacture detail" style={{ width: '100%', height: '300px', objectFit: 'cover', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/manufacture_02.jpeg')} onClick={() => showPreview('/manufacture_02.jpeg')} />
          </div>

          <div className="specialty-card">
            <h3>Engineering Capabilities</h3>
            <ul className="specialty-list">
              <li>Custom thermal systems and autoclaves</li>
              <li>Medical-grade furniture and equipment</li>
              <li>Heavy-duty stainless steel fabrication</li>
              <li>Turnkey installation and maintenance</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
};

export default Manufacturing;
